import { Button, TextField } from '@aws-amplify/ui-react';
import styled from '@emotion/styled';
import React, { useState } from 'react';
import ReactModal from 'react-modal';

const modalStyle = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
    overflow: 'hidden',
  },
  content: {
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
    maxWidth: '400px',
    background: '#fff',
    boxShadow: '0px 20px 15px rgba(0, 0, 0, 0.1)',
    borderRadius: '30px',
    border: 'none',
    inset: '50% auto auto 50%',
    padding: '25px 44px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
};
const ButtonsDiv = styled.div({
  marginTop: 30,
  display: 'flex',
  flexDirection: 'row',
  gap: '50px',
});
function PopupCreatePost({ onPopup, handleClosePopup, onCreate }) {
  const [isTitle, setIsTitle] = useState('');
  return (
    <ReactModal
      isOpen={!!onPopup}
      contentLabel="sent request"
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      ariaHideApp={false}
      onRequestClose={handleClosePopup}
      style={modalStyle}
    >
      <TextField
        onChange={(e) => setIsTitle(e.target.value)}
        placeholder="Post title"
        value={isTitle}
        isRequired

      />
      <ButtonsDiv>
        <Button onClick={() => { onCreate(isTitle); handleClosePopup(); }}>Create</Button>
        <Button onClick={handleClosePopup}>Cancel</Button>
      </ButtonsDiv>

    </ReactModal>
  );
}

export default PopupCreatePost;
